import {useState, Outlet, Navigate } from 'react-router-dom'


const ProtectdProgramRoute = () => {

   let proRight =   sessionStorage.getItem('programRight')
   
    return proRight === 'true'  ? <Outlet /> : <Navigate to='/'/>
}

export default ProtectdProgramRoute